package anjuros.development.modules

import anjuros.development.components.language.ResKey

enum class FAQ(
    val question: ResKey,
    val answer: ResKey
) {

    FAQ1(question = ResKey.FAQ1_Q, answer = ResKey.FAQ1_A),
    FAQ2(question = ResKey.FAQ2_Q, answer = ResKey.FAQ2_A),
    FAQ3(question = ResKey.FAQ3_Q, answer = ResKey.FAQ3_A),
    FAQ4(question = ResKey.FAQ4_Q, answer = ResKey.FAQ4_A),
    FAQ5(question = ResKey.FAQ5_Q, answer = ResKey.FAQ5_A),

}
